export default {
  TICKETING: 1,
  ENCUESTA: 2,
  CALENDAR: 3,
  FILE_MANAGER: 4,
  CLIENTES: 5,
  NOTAS_DE_PEDIDO: 7,
  LAB: 8,
};
